/**
 * O'SCOP GE — Feature flags
 * -----------------------------------------------
 * Deux sources possibles, dans l'ordre de priorité :
 *   1. window.__OSCOP_FEATURE_FLAGS__   (poussé par useFeatureFlags à la lecture serveur)
 *   2. localStorage ff_<name>            (override manuel admin via DevTools)
 *   3. DEFAULTS                          (fallback si rien n'est connu)
 *
 * Les flags SERVEUR centralisés font autorité : useFeatureFlags() les charge au login
 * et les repose toutes les 60 secondes. Pour une prise en compte immédiate, l'utilisateur
 * peut recharger la page (location.reload).
 *
 * ⚠️ Un interrupteur suspend une fonctionnalité. Il ne remplace pas une sauvegarde
 *    ni le retour à un artefact logiciel testé.
 */

const DEFAULTS = {
  lot3_aujourdhui: true,
  lot4_preparation_paie: true,
};

function readRuntime() {
  const w = typeof window !== "undefined" ? window : {};
  const injected = w.__OSCOP_FEATURE_FLAGS__ || {};
  // Les flags serveur sont au format { lot3_aujourdhui: { state: 'enabled' } }, les flags locaux boolean.
  const serverNormalized = {};
  for (const [k, v] of Object.entries(injected)) {
    if (v && typeof v === "object" && "state" in v) {
      serverNormalized[k] = v.state === "enabled";
    } else {
      serverNormalized[k] = Boolean(v);
    }
  }
  const result = { ...DEFAULTS, ...serverNormalized };
  try {
    if (typeof localStorage !== "undefined") {
      for (const key of Object.keys(DEFAULTS)) {
        const v = localStorage.getItem(`ff_${key}`);
        if (v === "0" || v === "false") result[key] = false;
        if (v === "1" || v === "true") result[key] = true;
      }
    }
  } catch (_) { /* localStorage indispo */ }
  return result;
}

export function isFeatureEnabled(name) {
  return Boolean(readRuntime()[name]);
}

export function allFlags() {
  return readRuntime();
}
